import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { VestingTask } from '../../types/vesting-tasks.types';
import { useAppQuery } from '../use-app-query.hook';

export const useScenarioVestingSars = ({
  scenarioId,
  numberOfFetchedItems = 100,
  currentPage = 1,
}: {
  currentPage?: number;
  numberOfFetchedItems?: number;
  scenarioId: string;
}) => {
  const queryClient = useQueryClient();
  const skip = (currentPage - 1 <= 0 ? 0 : currentPage - 1) * numberOfFetchedItems;
  const { data, isLoading, refetch } = useAppQuery<
    { totalPages: number; vestingTasks: VestingTask[] },
    HttpException
  >({
    queryKey: [
      QueryKey.GET_SCENARIO_VESTING_SARS,
      {
        page: currentPage,
        skip,
        numberOfFetchedItems,
      },
    ],
    queryFn: () =>
      ApiService.get(
        { endpoint: BackendRoute.SCENARIOS, routePath: [scenarioId, 'grants-for-scenario'] },
        {
          queryParams: {
            take: numberOfFetchedItems,
            skip,
            sarOnly: true,
          },
        },
      ),
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SCENARIO_VESTING_SARS] });
  }, [queryClient]);

  return {
    invalidateQuery,
    scenarioVestingSars: data?.vestingTasks,
    totalPages: data?.totalPages,
    isLoading,
    refetch,
  };
};
